// extracted by mini-css-extract-plugin
export default {"container":"Agreement_container__RjqBk","wrapper":"Agreement_wrapper__SscsR","logo":"Agreement_logo__5djXv","left-logo":"Agreement_left-logo__lngA-"};